import {GET_DATA_LAYOUT_LAYOUT, SET_DATA_LAYOUT_LAYOUT,GET_DATA_Notification,SET_DATA_LOGOUT, UPDATE_DATA_NOTIFICATION} from '../actions/actionTypes'
import {RequertLayoutLayoutFaileAction, GetDataLayoutLayoutSuccessAction,GetDataNotificationSuccessAction,RequertNotificationFaileAction,
 IsResultAction ,LogOutSuccessAction
,RequertLogOutFaileAction
} from '../actions'

import { put, takeLatest} from 'redux-saga/effects'
import { Api } from './api'

function* GetDataLayout(){
    try{
        const DataLayout = yield Api.GetDataLayoutFromApi();
        yield put(GetDataLayoutLayoutSuccessAction(DataLayout))
    }catch(error){
        yield put(RequertLayoutLayoutFaileAction(error))
    }
}
export function* watchGetDataLayout(){
    yield takeLatest(GET_DATA_LAYOUT_LAYOUT, GetDataLayout)
}

function* SetDataLayout(action){
    try{
        const isResult = yield Api.SetDataNotification(action.DataLayout);
        if(isResult)
        {
            yield put(IsResultAction(isResult))
        }
        else
        {
            yield put(RequertLayoutLayoutFaileAction("error"))
        }
    }catch(error){
        yield put(RequertLayoutLayoutFaileAction(error))
    }
}
export function* watchSetDataLayout(){
    yield takeLatest(SET_DATA_LAYOUT_LAYOUT, SetDataLayout)
}
//Noti
function* GetDataNoti(action){
    try{
        const DataNoti = yield Api.GetDataNotification(action.DataNoti);
        yield put(GetDataNotificationSuccessAction(DataNoti))
    }catch(error){
        yield put(RequertNotificationFaileAction(error))
    }
}
export function* watchGetDataNoti(){
    yield takeLatest(GET_DATA_Notification, GetDataNoti)
}
function* UpdateDataNotification(){
    try {
        const isResult = yield Api.UpdateDataNotificationApi();
        if (isResult) {
            yield put(IsResultAction(isResult));
        }
        else {
            yield put(RequertNotificationFaileAction("error"));
        }
    } catch (error) {
        yield put(RequertNotificationFaileAction(error));
    }
}
export function* watchUpdateDataNotification(){
    yield takeLatest(UPDATE_DATA_NOTIFICATION, UpdateDataNotification)
}
//logout
function* LogOut(){
    try{
        const data = yield Api.LogOut();
        yield put(LogOutSuccessAction(data))
    }catch(error){
        yield put(RequertLogOutFaileAction(error))
    }
}
export function* watchGetDataLogOut(){
    yield takeLatest(SET_DATA_LOGOUT, LogOut)
}